
import ReactGA from "react-ga4";

export const sendGA = function (event, arg) {
    ReactGA.event(event, arg);
}

export const sendAnalytic = function (event, arg) {
    sendGA(event, arg)
}